import {
  WithBadge
} from "./chunk.YZP3RYP4.js";
import {
  ARROW_RIGHT,
  DISABLED,
  consts_exports
} from "./chunk.4ZR5ZGBX.js";
import {
  JbIntElementInit
} from "./chunk.62T75WFP.js";
import {
  __decorateClass,
  __superGet
} from "./chunk.Y3TZ4FJV.js";

// src/components/icon/icon.ts
import { css } from "lit";
import { customElement, property } from "lit/decorators.js";
var JbIntElement = JbIntElementInit();
var JbIntIcon = class extends WithBadge(JbIntElement) {
  constructor() {
    super(...arguments);
    this.animation = void 0;
    this.hovered = false;
    this.name = "ARROW_DOWN";
  }
  /*  Just name, sets icon and default animation of that icon. 
      Name + animation, sets icon and defined animation. 
      Name + animation: none, sets icon and disables hover animation. */
  _classes() {
    let classList = [];
    if (!this.name) return "";
    if (!this.animation) classList = [this.name.toLowerCase().replaceAll("_", "-")];
    else classList = [this.animation.toLowerCase().replaceAll("_", "-")];
    if (this.hovered && this.animation !== "NONE") classList.push("hovered");
    if (this.animation === "NONE") classList.push("no-animation");
    return classList.join(" ");
  }
  render() {
    let icon = consts_exports[this.name]?.(this._classes());
    if (!icon && this.name?.startsWith("ARROW_")) icon = ARROW_RIGHT(this._classes());
    if (!icon) icon = DISABLED(this._classes());
    return icon;
  }
};
JbIntIcon.styles = [
  __superGet(JbIntIcon, JbIntIcon, "styles"),
  css`
      :host {
        display: inline-block;
        height: 100%;
      }

      svg {
        /* allow svg to be sized by host element */
        height: inherit;
        width: inherit;

        &,
        & * {
          /* default hover transition for all icons */
          transition: transform 0.3s ease-out 0s;
        }
      }

      svg,
      path,
      g,
      circle,
      rect,
      line {
        /* allows setting color web component */
        color: inherit;
      }

      /* ===== Arrows Special Exceptions ===== */

      .arrow-up {
        transform: rotate(-90deg);
      }

      .arrow-down {
        transform: rotate(90deg);
      }

      .arrow-left,
      .arrow-left-small {
        transform: rotate(180deg);
      }

      /* ===== Hover Animations ===== */

      .chat.hovered,
      .chat:hover {
        transform: scale(1.19, 1.125);
      }

      .heart.hovered,
      .heart:hover {
        transform: scale(1.125);
      }

      .rotate.hovered,
      .rotate:hover {
        transform: rotate(90deg);
      }

      .search.hovered,
      .search:hover {
        transform: rotate(75deg);
      }

      .burger.hovered,
      .burger:hover {
        transform: matrix(1, 0, 0, 0.9, 0, 0);
      }

      .profile-thin.hovered :first-child,
      .profile-thin:hover :first-child {
        transform: translateY(-2px);
      }
    `
];
__decorateClass([
  property()
], JbIntIcon.prototype, "animation", 2);
__decorateClass([
  property({ type: Boolean })
], JbIntIcon.prototype, "hovered", 2);
__decorateClass([
  property()
], JbIntIcon.prototype, "name", 2);
JbIntIcon = __decorateClass([
  customElement("jb-int-icon")
], JbIntIcon);

export {
  JbIntIcon
};
